<template>
  <course-image-uploader :value="image" @input="onImageInput" />
</template>

<script>
import CourseImageUploader from "shared/widgets/upload/image/CourseImageUploader.vue";

export default {
  name: "ImageBlock",
  components: { CourseImageUploader },
  props: {
    value: null,
  },
  data() {
    return {
      image: this.value,
    };
  },
  methods: {
    onImageInput(value) {
      this.$emit("input", value);
      this.$emit("update");
    },
  },
};
</script>
